import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { BaseUrl } from "../../BaseUrl/BaseUrl";
import { Tooltip } from "@mui/material";
import Batuk from "../../assets/images/new/fav-removebg-preview.png";
import ComingSoonModal from "../ComingSoonModal";
import { LoaderContext } from "../../AuthContext/AuthContext";
import placeholderImg from "../../assets/images/new/fav-removebg-preview.png";
import Select from "react-select";
import Breadcrumbs from "../Breadcrumb";
import { customSelectStyles } from "../../middlewares/Utils";
import "../../Pages/BookPandit/BookPandit.css";
const MyStore = () => {
  const [mydata, setMydata] = useState([]);
  const [mydataMobile, setMydataMobile] = useState([]);
  const [Product, setProduct] = useState([]);
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [noElement, setNoElement] = useState(12);
  const [catId, setCatId] = useState(null);
  const [selectedCatId, setSelectedCatId] = useState(null);
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);
  const location = useLocation();

  const { setLoader, loader, activeCategory, setActiveCategory } =
    useContext(LoaderContext);
  useEffect(() => {
    setLoader(true);
    axios
      .get(`${BaseUrl}/ProductCategory`)
      .then((res) => {
        const responseData = res.data.DATA || [];
        const filteredData = responseData
          .filter((item) => item.ProductCount > 0)
        setMydata(filteredData);
        const options = responseData
          .filter((item) => item.CAT_ID && item.CAT_NAME)
          .map((item) => ({
            value: item.CAT_ID,
            label: item.CAT_NAME,
          }));
        setMydataMobile(options);
        console.log(responseData);
        const storedCatId = sessionStorage.getItem("selectedCatId");
        if (Number(storedCatId)) {
          setCatId(Number(storedCatId));
          setSelectedCatId(Number(storedCatId));
        } else {
          setCatId(responseData[0].CAT_ID);
          setSelectedCatId(responseData[0].CAT_ID);
        }
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
    // setShowModal(true);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768); // Adjust breakpoint as needed
    };

    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    // debugger;
    setLoader(true);
    const data = localStorage.getItem("userID") || "";
    axios
      .post(
        `${BaseUrl}/HomeWebservice?CAT_ID=${catId}&COUNTRY_ID=1&USER_ID=${data}`,
        {
          START: 1,
          END: 1000000000,
          WORD: search,
        }
      )
      .then((res) => {
        const responseData = res.data.DATA;
        setLoader(false);
        const allProducts = [];
        responseData.forEach((category) => {
          if (Array.isArray(category.PRODUCT_LIST)) {
            category.PRODUCT_LIST.forEach((product) => {
              allProducts.push(product);
            });
          }
        });
        setProduct(allProducts);
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  }, [catId, search]);

  const Slice = Product.slice(0, noElement);
  const viewMore = (e) => {
    e.preventDefault();
    setNoElement((prevNoElement) => prevNoElement + 12);
  };
  console.log("selectedCatId", selectedCatId);
  const addToCart = (product) => {
    const newSlug = product?.ProductSlug;

    if (catId) {
      sessionStorage.setItem("selectedCatId", catId);
    }

    navigate(`/product-details/${newSlug}`, {
      state: {
        ...product,
        catId: catId,
      },
    });
  };

  // useEffect(() => {
  //   debugger;
  //   if (!catId) {
  //     // const storedCatId = sessionStorage.getItem("selectedCatId");
  //     const storedCatId = 5;

  //     if (storedCatId) {
  //       setCatId(storedCatId);
  //       setSelectedCatId(storedCatId);
  //     }
  //   }
  // }, []);

  // useEffect(() => {
  //   debugger;
  //   let recoveredCatId = location.state?.catId;

  //   if (!recoveredCatId) {
  //     recoveredCatId = sessionStorage.getItem("selectedCatId");
  //   }

  //   if (recoveredCatId) {
  //     // setCatId(recoveredCatId);
  //     setSelectedCatId(recoveredCatId);
  //   }
  // }, [location.state]);

  // const { id } = useParams();

  // useEffect(() => {
  //   debugger;
  //   if (id) {
  //     setCatId(id);
  //     setSelectedCatId(id);
  //   }
  // }, [id]);

  const handleClear = () => {
    setSearch("");
  };
  const handleCategoryChange = (value) => {
    setCatId(value);
    setSelectedCatId(value);
  };
  return (
    <>
      <section style={{ background: "white" }}>
        <div className="container">
          <div className="container-fluid py-4">
            <div style={{ padding: "8px" }}>
              <Breadcrumbs />
            </div>
            <div className="row">
              {/* Sidebar */}
              {!isMobile ? (
                <div
                  className="left col-md-3 col-sm-4 "
                // style={{ marginLeft: "10px" }}
                >
                  <div>
                    <h4
                      className=" custom-list-item clearfix"
                      style={{
                        fontFamily: "poppins",
                        fontSize: "20px",
                        borderBottom: "1px solid lightgray",
                        textTransform: "none",
                        padding: "12px",
                      }}
                    >
                      Product Categories
                    </h4>
                    <ul className="margin-bottom-25 sidebar-menu">
                      {mydata?.length > 0 ? (
                        mydata.map((category, index) => (
                          <li
                            className="list-group-item clearfix"
                            // style={{ padding: "10px 15px" }}
                            key={category.CAT_ID}
                          >
                            <div

                              onClick={() =>
                                handleCategoryChange(category.CAT_ID)
                              }
                              className={`d-flex align-items-center ${selectedCatId === category.PUJACAT_ID
                                ? "active"
                                : "notActive"
                                }`}

                              style={{ color: `${selectedCatId === category.CAT_ID ? '#a52444' : 'black'} `, textWrap: 'nowrap', fontWeight: `${selectedCatId === category.CAT_ID ? 'bold' : ''} ` }}
                            >

                              <i className="fa fa-angle-right me-2"></i>
                              {/* <span>{category.CAT_NAME}</span> */}
                              {category.CAT_NAME?.length > 30 ? (
                                <Tooltip title={category.CAT_NAME}>
                                  {`${category.CAT_NAME.substring(0, 19)}...`}
                                </Tooltip>
                              ) : (
                                category.CAT_NAME
                              )}
                            </div>
                          </li>
                        ))
                      ) : (
                        <li className="list-group-item">
                          No categories available
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
              ) : (
                <Select
                  styles={customSelectStyles}
                  options={mydataMobile}
                  placeholder="Select Category"
                  value={mydataMobile.find(
                    (option) => option.value === catId
                  )}
                  onChange={(selectedOption) => {
                    setCatId(selectedOption.value);
                    setSelectedCatId(selectedOption.value);
                  }}
                />
              )}
              {/* Main Content */}
              <main className="col-md-9 col-sm-8">
                {!isMobile ? (
                  <div
                    className="mb-4 custom-search"
                    style={{ marginLeft: "22px" }}
                  >
                    <input
                      type="text"
                      className="custom-search-input"
                      placeholder="Search Product"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </div>
                ) : (
                  ''
                )}

                {/* Product Grid */}
                <div
                  className="row "
                  style={{
                    minHeight: "50vh",
                    justifyContent: "left",
                    marginLeft: "20px",
                  }}
                >
                  {Slice?.filter((product) =>
                    search
                      ? product.PRODUCT_NAME.toLowerCase().includes(
                        search.toLowerCase()
                      )
                      : true
                  ).length > 0 ? (
                    Slice.filter((product) =>
                      search
                        ? product.PRODUCT_NAME.toLowerCase().includes(
                          search.toLowerCase()
                        )
                        : true
                    ).map((product, index) => (
                      <div
                        key={index}
                        className="col-xl-4 col-lg-6 col-md-6 col-sm-6 rounded"
                      >
                        <div
                          className="card shadow-md product-card"
                          onClick={() => addToCart(product)}
                          style={{
                            cursor: "pointer",
                            maxWidth: isMobile ? "20em" : "250px",
                            border: "none",
                            height: "350px", // ✅ fixed height for all cards
                          }}
                        >
                          <div
                            className="card-img-container"
                            style={{ height: "200px", overflow: "hidden" }}
                          >
                            <img
                              src={
                                product.PRODUCT_IMG.length === 0
                                  ? placeholderImg
                                  : product.PRODUCT_IMG[0]
                              }
                              alt={product.PRODUCT_NAME}
                              className="card-img-top"
                              style={{ height: "100%", objectFit: "contain" }}
                            />
                          </div>
                          <div
                            className="card-body p-1 d-flex flex-column"
                            style={{ width: "13rem" }}
                          >
                            <h6
                              style={{
                                fontSize: "18px",
                                color: "#8f3246",
                                fontWeight: "600",
                                textAlign: "center",
                              }}
                            >
                              {product.PRODUCT_NAME.slice(0, 30)}
                            </h6>

                            <p
                              className="card-text mb-2"
                            // style={{ textAlign: "center" }}
                            >
                              <span
                                className=""
                                style={{ color: "#a52444", fontSize: "20px" }}
                              >
                                Rs{" "}
                                {product.PRODUCT_PRICE -
                                  Math.round(Number(product.DiscountAmount))}
                              </span>
                              {Number(product.DISCOUNT) !== 0 &&
                                product.DISCOUNT !== null &&
                                product.DISCOUNT !== undefined && (
                                  <span
                                    className="text-muted ms-2"
                                    style={{ fontSize: "20px", color: "grey" }}
                                  >
                                    <s>Rs {product.PRODUCT_PRICE}</s>
                                  </span>
                                )}
                            </p>
                            <div className="d-flex justify-content-between align-items-center">
                              {Number(product.DISCOUNT) !== 0 &&
                                product.DISCOUNT !== null &&
                                product.DISCOUNT !== undefined && (
                                  <span
                                    style={{
                                      background: "#a52444",
                                      padding: "10px 13px",
                                      cursor: "text",
                                    }}
                                    className="badge"
                                  >
                                    {product.DISCOUNT}% Off
                                  </span>
                                )}

                              <button
                                className="Normal-app-btn ms-auto"
                                style={{
                                  padding: "5px 10px",
                                  fontSize: "12px",
                                }}
                              >
                                View Details{" "}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : loader === false ? (
                    <div
                      className="col-12 d-flex justify-content-center align-items-center"
                      style={{ minHeight: "300px" }}
                    >
                      {search ? (
                        <div className="text-center">
                          <img src={Batuk} alt="" />
                          <h5 className="text-muted">No products found</h5>
                          <button
                            className="btn btn-outline-secondary mt-3"
                            onClick={handleClear}
                          >
                            Clear Search
                          </button>
                        </div>
                      ) : (
                        !loader && (
                          <div className="d-flex flex-column align-items-center justify-content-center vh-90 text-center mt-4">
                            <img
                              src={Batuk}
                              alt="Empty Cart"
                              className="img-fluid mb-3"
                              style={{ maxWidth: "200px" }}
                            />
                            <h5 className="fw-bold">
                              No products available for this catagory
                            </h5>
                            <p className="text-muted">
                              Please explore our other categories.
                            </p>
                            {/* <Link to="/my-store">
                    <button
                      style={{ background: "#a52444" }}
                      className="text-white btn me-2"
                    >
                      Add Products
                    </button>
                  </Link> */}
                          </div>
                        )
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                </div>

                {/* View More Button */}
                {noElement < Product.length && (
                  <div className="d-flex justify-content-center mt-4">
                    <button className="Normal-subcribe-btn" onClick={viewMore}>
                      View More Products
                    </button>
                  </div>
                )}
              </main>
            </div>
          </div>
        </div>
      </section>
      <ComingSoonModal show={showModal} onClose={() => navigate("/")} />
    </>
  );
};

export default MyStore;
